module.exports = __webpack_public_path__ + "static/media/gift-box-icon.b8077f2f.svg";